<template>
  <div>
    <tree-view
      v-for="device in devices"
      :key="device.id"
      :name="device.name"
      :data="device"
      :paths="dynamicPath"
      :root="root"
      :padd="false"
    />
  </div>
</template>

<script>
import TreeView from '@/components/TreeView'

export default {
  name: 'sidepanel',
  components: { TreeView },
  props: {
    root: String
  },
  data() {
    return {
    }
  },
  computed: {
    devices() {
      return this.$store.getters.devices
    },
    childrenCount() {
      let count = 0
      let children = this.devices[0].children
      while(children) {
        count += 1
        children = children[0].children
      }
      return count
    },
    dynamicPath() {
      return Array(this.childrenCount).fill('children')
    }
  }
}
</script>
